import axios from 'axios';
import { withSnackbar } from 'notistack';
import config from '../config';
import { trackLogOut } from './mixpanel';
import Cookies from 'universal-cookie'
import { getGlobalCookie, eraseGlobalCookie, setGlobalCookie,getLocalStorageInfo,clearCookie,toastFlashMessage,triggerForceChangePasswordModal} from './';
var axiosInstance = axios.create();
const cookies = new Cookies();
let ipRestrictionHandled = false;
axiosInstance.defaults.baseURL = config.api.networkInterface;
axiosInstance.interceptors.request.use(function (config) {
  let lessorAccess = JSON.parse(getGlobalCookie('lessorAccess'));
  if(lessorAccess){
    config['headers']['Authorization'] = lessorAccess.access
  }
  return config;
},function (error) {
  return Promise.reject(error);
});
axiosInstance.interceptors.response.use(
  function (response) {
    // debugger
    // Access token expired
  if(response.data.statusCode == 404){

  }else if (response.data.statusCode == 1001) {
    localStorage.clear()
    eraseGlobalCookie('lessorAccess')
    eraseGlobalCookie('domain')
    if(!window.location.href.includes('login') && !window.location.href.includes('signup')){
        setGlobalCookie('redirectURIRecords', window.location.href, 3)
    }
    window.location.assign('/login')
  }else if (response.data.statusCode == 1002) {
    localStorage.clear();
    eraseGlobalCookie('lessorAccess')
    eraseGlobalCookie('domain')
    eraseGlobalCookie('userName')
    eraseGlobalCookie('hasMultilLessorAccess')
    if(!window.location.href.includes('login') && !window.location.href.includes('signup')){
        setGlobalCookie('redirectURIRecords', window.location.href, 3)
    }
    window.location.assign('/login')
  } else if (response?.data?.statusCode == 1013) {
    toastFlashMessage("Your password has expired. Please change your password.", 'error');
    triggerForceChangePasswordModal(response);
  } else if (response.data.statusCode == 3004) {
    localStorage.clear();
    eraseGlobalCookie('lessorAccess')
    eraseGlobalCookie('domain')
    eraseGlobalCookie('userName')
    if(!window.location.href.includes('login') && !window.location.href.includes('signup')){
        setGlobalCookie('redirectURIRecords', window.location.href, 3)
    }
    window.location.assign('/login')
  } 
  else if (response.data.statusCode == 3005) {
    if(!ipRestrictionHandled){
      ipRestrictionHandled = true;
      toastFlashMessage("You are accessing from IP which is not whitelisted by your Admin. Please contact your SPARTA ADMIN", 'error');
      localStorage.clear();
      clearCookie('lessorAccess', '.sparta.aero', '/')
      eraseGlobalCookie('lessorAccess')
      eraseGlobalCookie('domain')
      eraseGlobalCookie('userName')
      eraseGlobalCookie('hasMultilLessorAccess')
      cookies.remove('lessorAccess', { path: "/", domain: "sparta.aero" })
      trackLogOut(getLocalStorageInfo())
      setTimeout(() => {
        window.location.assign('/login')
      }, 2000)
    }
  } else if (response.data.statusCode == 3001 || response.data.statusCode == 3002) {
    // window.location.assign('/mr-calculator/logs')
  }
    // Valid Lessor Acccess

    return response;
  },
  function (error) {
    return error.response;
  }
);
export default axiosInstance;
